import { AndBlockValues, EntityType } from './enroll-node-editor.types';

export const getUsedEntityTypes = (watchedBlocks: AndBlockValues[] = []): EntityType[] => {
  const types = watchedBlocks
    .map((block) => block.entityType)
    .filter((type): type is EntityType => Boolean(type));
  return [...new Set(types)];
};
